<nav id="nav" class="navbar navbar-inverse py-0" [ngClass]="[(isMenuActive)?'hasShell':'noShell', isMobile ? '' : 'px-4']">
    <a class="navbar-brand" [ngClass]="{'me-auto': !isMobile}" [routerLink]="headerLink">
        <img [width]="headerIconWidth" [src]="headerIcon" class="d-inline-block align-top me-2 pt-2" alt="brand icon"
            [ngClass]="{'me-2': !isMobile}" />
        @if(!isMobile){
        <span class="font-32 align-top ps-2 link-underline-opacity-0 text-white">{{pageTitle}}</span>
        }
    </a>
    <ul class="d-flex flex-row justify-content-end align-items-center mb-0" [ngClass]="{'me-6': showAssistant}">
        <li class="nav-item">
            @if(_userService.loggedIn()){
            <a class="nav-link" style="color: #fff" (click)="logout()">Logout</a>
            }
            @else {
            <a class="nav-link" style="color: #fff" [routerLink]="['/home']">Login</a>
            }
        </li>
        <li class="nav-vertical-border"></li>
        <li class="nav-item">
            @if(isRoot){
            <span class="root-layout" [routerLink]="['/']">
                <span class="sprite-assistant-logo"></span>
            </span>
            }
            @else {
            <a class="align-self-center" [routerLink]="['/']">
                <span class="sprite-assistant-logo mx-1"></span>
            </a>
            }
        </li>
        <li class="nav-vertical-border"></li>
        <li class="nav-item me-auto">
            <img class="pt-1 ms-1" src="/assets/icons/protiviti-only.png" [height]="isMobile ? 32 : 45">
        </li>
    </ul>
    @if(isMenuActive && showAssistant) {
    <div id="assistant-menu" (click)="showAssistantMenu()"
        class="hamburger assistant-layout h-100 d-flex flex-column justify-content-center align-items-center">
        <div class="my-1 mx-2"></div>
        <div class="my-1 mx-2"></div>
        <div class="my-1 mx-2"></div>
    </div>
    }
</nav>
@if(isShellEdit || isAccountRequest) {
<div class="title-link-existing-layout" id="shell-title">
    <div class="d-flex flex-row justify-content-between align-items-center mx-3" style="height: 42px">
        <span class="link-existing-font" [ngClass]="{'ms-4': !isMobile}" id="shell-name"
            [class.titleLinkExisting]="isLinkExistingTeamsSite"></span>
        @if(!isLinkExistingTeamsSite) {
        <span class="mod-font" id="shell-mod" [ngClass]="{'me-4': !isMobile}" ></span>
        }
    </div>
</div>
}